import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import { useSelector } from "react-redux";
import { selectRecentTransactions } from "../features/recentTransactions/recentTransactionSlice";

function DataTable() {
  //   let rows = [
  //     {
  //       id: 1,
  //       merchant: "Walgreens",
  //       amount: 1000,
  //       date: "10/09/2023",
  //       type: "debit",
  //     },
  //     {
  //       id: 2,
  //       merchant: "Nike",
  //       amount: 10000,
  //       date: "10/09/2023",
  //       type: "credit",
  //     },
  //     {
  //       id: 3,
  //       merchant: "Forever 21",
  //       amount: 10000,
  //       date: "10/09/2023",
  //       type: "debit",
  //     },
  //   ];

  const columns = [
    {
      field: "merchant",
      width: 150,
      flex: 0.3,
      renderHeader: () => (
        <strong className="text-white text-center">Merchant</strong>
      ),
      //   renderCell: (params) => (
      //     <div className="text-white text-center">{params.value}</div>
      //   ),
    },
    {
      field: "date",
      headerName: "Date of Transaction",
      width: 175,
      flex: 0.4,
      renderHeader: () => (
        <strong className="text-white text-center">Date</strong>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 100,
      flex: 0.2,
      renderHeader: () => (
        <strong className="text-white text-center">Amount</strong>
      ),
    },
    {
      field: "type",
      headerName: "",
      width: 50,
      flex: 0.1,
      renderCell: (params) => {
        if (params.value == "debit") {
          return <CallMadeIcon style={{ fill: "#FF0000" }} />;
        } else {
          return <CallReceivedIcon style={{ fill: "#00FF00" }} />;
        }
      },
    },
  ];

  const recentTransactions = useSelector(selectRecentTransactions);
  //   const recentTransactions = transactions?.creditCard;
  //   console.log(recentTransactions);
  let rows = recentTransactions;

  //   let rows = recentTransactions
  //     .filter(function (recentTransactions) {
  //       return recentTransactions.type == entity;
  //     })
  //     .map(function (row) {
  //       return row;
  //     });

  return (
    <div class="bg-transparent mx-2 my-0.5 p-5 width-full ">
      <DataGrid
        hideFooter
        rows={rows}
        columns={columns}
        getRowId={(row) => row.merchant}
      />
    </div>
  );
}

export default DataTable;
